import { ExternalPayinSwitch } from "@/routes/(app)/_main-layout/_settings/-components/external-payin-switch";
import { hasRole } from "@/lib/auth";
import { VolumeApi } from "@/lib/volume-api";
import { createFileRoute, Navigate, redirect } from "@tanstack/react-router";
import { useSelectedApplication } from "@/hooks/use-selected-application";
import { CardWithHeader } from "@/components/card-with-header";
import { Separator } from "@/components/ui/separator";

export const Route = createFileRoute(
  "/(app)/_main-layout/_settings/settings/notifications",
)({
  component: () => <NotificationsComponent />,
  loader: async ({ context }) => {
    const api = new VolumeApi(
      context.accessToken,
      context.selectedApplicationId,
    );
    return api.getMerchant({ merchantId: context.merchantId });
  },
  beforeLoad: ({ context }) => {
    if (!hasRole("EDIT_SETTINGS", context.authorities)) {
      throw redirect({ to: "/settings/account-settings", search: true });
    }
  },
});

const NotificationsComponent = () => {
  const merchant = Route.useLoaderData();
  const context = Route.useRouteContext();
  const application = useSelectedApplication();
  if (!application) {
    return <div>Error: Application not found</div>;
  }
  if (!application.hasVirtualAccountsEnabled) {
    return <Navigate to="/settings/account-settings" />;
  }
  return (
    <CardWithHeader variant="exchange" title="Notifications">
      <div className="space-y-4">
        <div className="grid grid-cols-12 gap-4 items-center">
          <div className="col-span-2 text-black">External Payin Emails</div>
          <div className="col-span-8 text-volume-dark-grey">
            Receive an <b>email</b> notification when a payment is received to
            your virtual account, but was not initiated through the Volume
            platform.
          </div>
          <div className="ml-auto">
            <ExternalPayinSwitch
              currentValue={
                application.sendEmailForExternalPayinPayment ?? false
              }
              applicationId={application.applicationId}
              merchantId={merchant.merchantId}
              accessToken={context.accessToken}
              type="email"
            />
          </div>
        </div>
        <Separator className="my-4" />
        <div className="grid grid-cols-12 gap-4 items-center">
          <div className="col-span-2 text-black">External Payin Webhooks</div>
          <div className="col-span-8 text-volume-dark-grey">
            Receive a <b>webhook</b> notification when a payment is received to
            your virtual account, but was not initiated through the Volume
            platform.
          </div>
          <div className="ml-auto">
            <ExternalPayinSwitch
              currentValue={
                application.sendWebhookForExternalPayinPayment ?? false
              }
              applicationId={application.applicationId}
              merchantId={merchant.merchantId}
              accessToken={context.accessToken}
              type="webhook"
            />
          </div>
        </div>
      </div>
    </CardWithHeader>
  );
};
